"use client";

import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from "@bowfast/ui/components/sidebar";
import {
  AnchorIcon,
  AwardIcon,
  BarChart2Icon,
  BellIcon,
  CompassIcon,
  LayoutDashboardIcon,
  MapIcon,
  SettingsIcon,
  StarIcon,
  UsersIcon,
} from "lucide-react";
import type * as React from "react";
import { NavMain } from "~/components/nav-main";
import { NavUser } from "~/components/nav-user";
import { TeamSwitcher } from "~/components/team-switcher";

const data = {
  user: {
    name: "Dan Marinescu",
    roles: ["Skipper"],
    email: "dan@example.com",
    avatar: "/avatars/placeholder.jpg",
  },
  teams: [
    {
      name: "My Organisation",
      logo: <AnchorIcon />,
      plan: "Skipper",
    },
  ],
  navMain: [
    { title: "Dashboard", url: "/dashboard", icon: <LayoutDashboardIcon /> },
    { title: "Notifications", url: "/notifications", icon: <BellIcon /> },
  ],
  navVoyages: [
    { title: "Expeditions", url: "/expeditions", icon: <CompassIcon /> },
    { title: "Routes", url: "/routes", icon: <MapIcon /> },
  ],
  navFleet: [{ title: "Vessels", url: "/vessels", icon: <AnchorIcon /> }],
  navCrew: [
    { title: "Crew", url: "/crew", icon: <UsersIcon /> },
    { title: "Skills", url: "/skills", icon: <StarIcon /> },
  ],
  navCredentials: [{ title: "Certificates", url: "/certificates", icon: <AwardIcon /> }],
  navManage: [
    { title: "Reports", url: "/reports", icon: <BarChart2Icon /> },
    { title: "Settings", url: "/settings", icon: <SettingsIcon /> },
  ],
};

export interface AppSidebarUser {
  name: string;
  roles: string[];
  email: string;
  avatar: string;
}

export interface AppSidebarTeam {
  name: string;
  logo: React.ReactNode;
  plan: string;
}

export function AppSidebar({
  user,
  teams: teamsProp,
  loading = false,
  ...props
}: React.ComponentProps<typeof Sidebar> & {
  user?: AppSidebarUser;
  teams?: AppSidebarTeam[];
  loading?: boolean;
}) {
  const teams = teamsProp ?? data.teams;
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={teams} loading={loading} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        <NavMain label="Voyages" items={data.navVoyages} />
        <NavMain label="Fleet" items={data.navFleet} />
        <NavMain label="Crew" items={data.navCrew} />
        <NavMain label="Credentials" items={data.navCredentials} />
        <NavMain label="Manage" items={data.navManage} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user ?? data.user} loading={loading} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
